import React from 'react'
import styled from 'styled-components'
import RenderLocation from "./renderLoacation";
import RenderLinkMsg from "./renderLinkMsg";
import RenderDocMsg from "./renderDocMsg";
import TodoMsg from "./todoMsg";
import RenderFileMsg from "./renderFileMsg";
import RenderTextMsg from "./renderTextMsg";
import RenderOther from "./renderOtherMsg";
// import RenderDialogue from "./renderDialogue";
import RenderMixedMsg from "./renderMixedMsg";
import RenderImgMsg from "./renderImgMsg";
import RenderVideoMsg from "./renderVideoMsg"
import RenderRedPackageMsg from "./renderRedPackage";
import RenderCardMsg from "./renderCardMsg";
import RenderAgreeMsg from "./renderAgreeMsg";
import RenderVoiceCallMsg from "./renderVoiceCallMsg";
import RenderVoice from "./rendVoice";
import Emotion from "./emotion";

const MessageWrapper = styled.div`
  margin-bottom: 16px;
  word-wrap:break-word;
  word-break:break-all;
`

/**
 * @param {{ message: any, renderType?: 'search-sidebar' | 'chat-log' }} props
 * @desc renderType 渲染的是会话存档会话还是搜索记录
 * */ 
const LogMessage = (props) => {
  const { message, handleChange, source, renderType } = props
  // 渲染消息
  const renderMsg = (params) => {
    if (!params) return null
    const { msgtype } = params
    switch (msgtype) {
      case 'text':
        return <RenderTextMsg value={params} />
      case 'file':
        return <RenderFileMsg value={params} />
      case 'image':
        return <RenderImgMsg value={params} />
      case 'video':
        return <RenderVideoMsg value={params} />
      case 'external_redpacket':
      case 'redpacket':
        return <RenderRedPackageMsg value={params} />
      case 'emotion':
        return <Emotion value={params} />
      case 'location':
        return <RenderLocation value={params} />
      case 'card':
        return <RenderCardMsg value={params} />
      case 'agree':
      case 'disagree':
        return <RenderAgreeMsg value={params} />
      // case 'chatrecord':
      //   return <RenderDialogue value={params}/>
      case 'link':
        return <RenderLinkMsg value={params} />
      case 'docmsg': // 在线文档
        return <RenderDocMsg value={params} />
      case 'todo':
        return <TodoMsg value={params} />
      case 'revoke': // 撤回消息的操作不展示
        return null
      case 'mixed': // 混合消息
        return <RenderMixedMsg value={params} />
      case 'meeting_voice_call': // 通话分享
        return <RenderVoiceCallMsg value={params} />
      case 'voice': // 语音
        return <RenderVoice value={params} renderType={renderType} />
      default:
        return <RenderOther value={params} />
    }
  }

  const handleClick = (item) => {
    // http://zentao.weiwenjia.com/bug-view-54829.html 不再需要此逻辑
    // if (source === 'search-sidebar' && item.msgtype === 'text') {
    //   handleChange({ setType: 'message', ...item })
    // }
  }
  return (
    <MessageWrapper>
      {
        <div key={message.id}
          id={'message-' + message.id}
          onClick={() => handleClick(message)}
          style={message.sendType === 2 ? { display: "flex", justifyContent: "flex-end", marginLeft: '40px' } : { marginRight: '40px' }}
        >
          {renderMsg(message)}
        </div>
      }
    </MessageWrapper>
  )
}

export default LogMessage
